import { useAuth0 } from '@auth0/auth0-react'
import { useState } from 'react'

import { getEnvName, setEnvName, setStoredToken, type EnvName } from '~/config'
import { theme } from '~/theme'

export function LoginScreen() {
  const { loginWithRedirect } = useAuth0()
  const [advanced, setAdvanced] = useState(false)
  const [token, setToken] = useState('')
  const envName = getEnvName()

  const selectEnv = (next: EnvName) => {
    setEnvName(next)
    window.location.reload()
  }
  const enterWithToken = () => {
    setStoredToken(token.trim())
    window.location.reload()
  }

  return (
    <div style={wrap}>
      <div style={card}>
        <div style={kicker}>Zunou</div>
        <h1 style={h1}>Glass Office</h1>
        <p style={sub}>
          Watch your organization work — humans and AI agents, live, in one room.
        </p>

        <button onClick={() => void loginWithRedirect()} style={primary}>
          Enter the office →
        </button>
        <p style={note}>Sign in with your Zunou account.</p>

        <button onClick={() => setAdvanced((v) => !v)} style={link}>
          {advanced
            ? 'Hide connection options'
            : 'Connect with a token · choose environment'}
        </button>

        {advanced && (
          <div style={panel}>
            <div style={row}>
              {(['staging', 'prod'] as EnvName[]).map((e) => (
                <button
                  key={e}
                  onClick={() => selectEnv(e)}
                  style={envBtn(envName === e)}
                >
                  {e === 'staging' ? 'Staging' : 'Production'}
                </button>
              ))}
            </div>
            <textarea
              value={token}
              onChange={(ev) => setToken(ev.target.value)}
              placeholder="Paste a JWT to view a live org (read-only)"
              spellCheck={false}
              style={ta}
            />
            <button
              onClick={enterWithToken}
              disabled={!token.trim()}
              style={{ ...primary, marginTop: 8, opacity: token.trim() ? 1 : 0.5 }}
            >
              Enter with token →
            </button>
            <p style={note}>
              Environment: <b style={{ color: theme.cream }}>{envName}</b>. The token
              stays in your browser. Production is token-only for now.
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

const wrap: React.CSSProperties = {
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: theme.bg,
  padding: 16,
  boxSizing: 'border-box',
  overflowY: 'auto',
}
const card: React.CSSProperties = {
  width: '100%',
  maxWidth: 380,
  padding: '34px 30px',
  boxSizing: 'border-box',
  background: theme.panel,
  border: `1px solid ${theme.border}`,
  borderRadius: 14,
  textAlign: 'center',
}
const kicker: React.CSSProperties = {
  fontSize: 13,
  color: theme.terracottaLite,
  letterSpacing: 2,
  textTransform: 'uppercase',
}
const h1: React.CSSProperties = {
  margin: '8px 0 6px',
  fontSize: 26,
  color: theme.cream,
  fontWeight: 600,
}
const sub: React.CSSProperties = {
  margin: '0 0 24px',
  fontSize: 14,
  color: theme.textDim,
  lineHeight: 1.6,
}
const primary: React.CSSProperties = {
  width: '100%',
  padding: '12px 16px',
  fontSize: 15,
  fontWeight: 600,
  color: '#1a120e',
  background: theme.terracotta,
  border: 'none',
  borderRadius: 10,
  cursor: 'pointer',
}
const note: React.CSSProperties = {
  margin: '14px 0 0',
  fontSize: 12,
  color: theme.offline,
  lineHeight: 1.5,
}
const link: React.CSSProperties = {
  marginTop: 18,
  background: 'none',
  border: 'none',
  color: theme.textDim,
  cursor: 'pointer',
  fontSize: 12.5,
}
const panel: React.CSSProperties = {
  marginTop: 14,
  padding: 14,
  background: theme.bgRoom,
  border: `1px solid ${theme.border}`,
  borderRadius: 10,
  textAlign: 'left',
}
const row: React.CSSProperties = { display: 'flex', gap: 8, marginBottom: 10 }
const ta: React.CSSProperties = {
  width: '100%',
  height: 64,
  resize: 'vertical',
  boxSizing: 'border-box',
  background: theme.bg,
  color: theme.text,
  border: `1px solid ${theme.border}`,
  borderRadius: 8,
  padding: 8,
  fontSize: 12,
  fontFamily: 'monospace',
}
const envBtn = (selected: boolean): React.CSSProperties => ({
  flex: 1,
  padding: '8px 10px',
  fontSize: 13,
  color: selected ? '#1a120e' : theme.text,
  background: selected ? theme.terracottaLite : theme.panelAlt,
  border: `1px solid ${selected ? theme.terracottaLite : theme.border}`,
  borderRadius: 8,
  cursor: 'pointer',
})
